import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/app/client-layout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/common/ContentIdeaPopup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/common/FAQ.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/common/ImageTextSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/common/PageSchemas.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/common/ProcessSteps.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/common/StructuredData.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/common/UniversalPageHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/services/ConsultationCTA.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/apps/web/src/index.css");
